import { createApp } from 'vue'
import ProgressDashboard from '../components/ProgressDashboard.vue'

export function mountProgress() {
  const el = document.getElementById('progress-app')
  if (!el) return
  createApp(ProgressDashboard).mount(el)
}
